import { SubscriptionsAddToCartWidget } from './widget'
import { isContainerDefined, registerToContainer } from './container/widgets-container'

if (isContainerDefined()) {
  registerToContainer('SubscriptionsAddToCartWidget', () => {
    return new SubscriptionsAddToCartWidget()
  })
} else {
  console.log('yotpoWidgetsContainer is not defined')
}
